module.exports = __webpack_public_path__ + "static/img/320x100-barclays.e033809.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/leagues/320x100-barclays.jpg
// module id = FIzV
// module chunks = 2